<template>
    <el-button
            :disabled="!isMdfStatue"
            style="float: left"
            @click="clickCreateNewGroupCraft"
            type="primary"
            icon="el-icon-circle-plus"
            size="mini">
        新建小组任务
    </el-button>
</template>

<script>
    import {mapMutations, mapState, mapGetters} from 'vuex'

    export default {
        name: "CreateNewGroupButton",
        computed: {
            priceSum() {
                let sum = 0
                this.currentCraft.size_records.forEach(sizeRecord => {
                    sum += sizeRecord.price
                })
                return sum
            },

            ...mapState(['PlanNumHasChange', 'currentCraft']),
            ...mapGetters({isMdfStatue: 'currentCraftIsMdf'})
        },
        methods: {
            checkPlanNum() {
                // 检测不通过
                if (this.currentCraft.plan_num - this.currentCraft.has_planed <= 0) {
                    this.$message({
                        type: 'error',
                        showClose: true,
                        message: '可分配通知数量不足（必须大于0)',
                    })
                    return false
                }

                // 检测通过
                return true
            },
            checkPrice() {
                // 检测不通过
                if (this.priceSum <= 0) {
                    this.$message({
                        type: 'error',
                        showClose: true,
                        message: '价格为必填项',
                    })
                    return false
                }

                // 检测通过
                return true

            },

            clickCreateNewGroupCraft() {
                if (this.checkPlanNum() && this.checkPrice()) {
                    this.setShowCraftCreateGroup(true)
                }
            },
            ...mapMutations(['setShowCraftCreateGroup'])
        }
        ,
    }
</script>

<style scoped>

</style>